import { api } from '../../../shared/lib/axios';
import type { Feedback } from '../../../shared/lib/api';

export const FEEDBACKS_KEYS = {
  all: ['feedbacks'] as const,
  list: (params?: object) => ['feedbacks', 'list', params] as const,
};

interface ListParams {
  collaboratorId?: string;
  managerId?: string;
  status?: string;
  limit?: number;
  offset?: number;
}

interface ListResponse {
  data: Feedback[];
  pagination?: { limit: number; offset: number; count: number };
}

export async function listarFeedbacks(params?: ListParams): Promise<ListResponse> {
  const query = new URLSearchParams();
  if (params?.collaboratorId) query.set('collaborator_id', params.collaboratorId);
  if (params?.managerId) query.set('manager_id', params.managerId);
  if (params?.status) query.set('status', params.status);
  if (params?.limit) query.set('limit', String(params.limit));
  if (params?.offset) query.set('offset', String(params.offset));
  const qs = query.toString();
  const { data } = await api.get<ListResponse>(`/feedbacks${qs ? `?${qs}` : ''}`);
  return data;
}

export async function buscarFeedback(id: string): Promise<Feedback> {
  const { data } = await api.get<Feedback>(`/feedbacks/${id}`);
  return data;
}

export interface CreateFeedbackPayload {
  collaboratorId: string;
  managerId: string;
  referencePeriod: string;
  behaviorRating: number;
  behaviorComment?: string;
  deliveriesRating: number;
  deliveriesComment?: string;
  qualityRating: number;
  qualityComment?: string;
  collaborationRating: number;
  collaborationComment?: string;
  punctualityRating: number;
  punctualityComment?: string;
  strengths?: string;
  improvements?: string;
  recommendations?: string;
}

export async function criarFeedback(payload: CreateFeedbackPayload): Promise<Feedback> {
  const { data } = await api.post<Feedback>('/feedbacks', payload);
  return data;
}

export async function atualizarFeedback(id: string, payload: Partial<CreateFeedbackPayload>): Promise<void> {
  await api.patch(`/feedbacks/${id}`, payload);
}

export async function publishFeedback(id: string): Promise<{ id: string; lifecycleStatus: string }> {
  const { data } = await api.post<{ id: string; lifecycleStatus: string }>(`/feedbacks/${id}/publish`);
  return data;
}

export async function releaseFeedback(id: string): Promise<{ id: string; lifecycleStatus: string }> {
  const { data } = await api.post<{ id: string; lifecycleStatus: string }>(`/feedbacks/${id}/release`);
  return data;
}

export async function buscarPeriodoAtivo(): Promise<{ referencePeriod: string | null }> {
  const { data } = await api.get<{ referencePeriod: string | null }>('/feedbacks/admin/period');
  return data;
}
